import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import store from "store/store";
import { notifyError } from "utils";
import { budgetBuilderSelectors } from "store/selectors";
import { IS_DEV } from "globals/constants";

import { budgetFactory } from "./actions";
import { mapCaseInstanceData } from "./utils";
import { collectResearchTeamDataForPeriod } from "./members";
import { api } from "services";


const collectVersionPeople = async (cachedPeopleById, versions = []) => {
	const requests = versions.reduce((acc, version) => {
		if (!cachedPeopleById?.[version?.creatorId]) {
			acc.push(api.person.get({ id: version?.creatorId }));
		}

		return acc;
	}, []);

	const response = await Promise.all(requests);

	let newCachedPeopleById = { ...cachedPeopleById };
	if (isNonEmptyArray(response)) {
		for (let person of response) {
			newCachedPeopleById[person.id] = person;
		}
	}

	return newCachedPeopleById;
};

const loadInstanceVariables = async ({ caseInstanceId, budgetType, fromRoot, currentPeriodNumber }) => {
	const caseInstance = await api.form.getVariables({ id: caseInstanceId });

	return mapCaseInstanceData(caseInstance, { budgetType, fromRoot, currentPeriodNumber });
};

export const loadCaseInstance = async (
	{
		caseInstanceId,
		budgetType = null,
		isRefresh = true,
		fromRoot = true,
	},
	state = store.getState(),
) => {
	const content = budgetBuilderSelectors.content(state);

	budgetType = budgetType || content.budgetType;

	const cachedPeopleById = budgetBuilderSelectors.cachedPeopleById(state);
	const currentPeriodNumber = budgetBuilderSelectors.currentPeriodNumber(state) || 1;

	try {
		budgetFactory.setIsFetching(true);

		const {
			payload,
			researchTeamFromBudgetBuilder,
			fromParent,
			unnamed,
			currentPeriod,
			versions,
			sponsoredCosts,
			externalCostShare,
			internalCostShare,
		} = await loadInstanceVariables({ caseInstanceId, budgetType, fromRoot, currentPeriodNumber });

		const rtDataForPeriod = await collectResearchTeamDataForPeriod(
			researchTeamFromBudgetBuilder,
			fromParent,
			unnamed,
			cachedPeopleById,
			currentPeriodNumber,
		);

		try {
			const cachedPeopleById = await collectVersionPeople(rtDataForPeriod.cachedPeopleById, versions);

			budgetFactory.setData({
				...content,
				budgetType,
				lineItems: {
					sponsoredCosts,
					externalCostShare,
					internalCostShare,
				},
				currentPeriod,
				payload,
				...rtDataForPeriod,
				cachedPeopleById,
			});

		} catch (e) {
			throw e;
		}

	} catch (error) {
		const message = IS_DEV ? error.message : "An error occurred fetching Research Team members.";

		notifyError(message, error);
		budgetFactory.setError(message);

	} finally {
		budgetFactory.setIsFetching(false);
	}
};
